import { TIERS } from "./pricing.js";
/** Doba operacyjna w minutach — górna granica każdej rezerwacji godzinowej. */
export const DAY_MIN = 1440;
/** Domyślne godziny pracy operatora: 8:00–16:00, krok 30 min (R-HOURS). */
export const DEFAULT_HOURS = { openMin: 8 * 60, closeMin: 16 * 60, stepMin: 30 };
/** Minimalny czas trwania usługi godzinowej (R-DUR). */
export const MIN_SERVICE_DURATION = 15;
/** Dozwolone stawki VAT (R-VAT). */
export const VAT_RATES = [23, 8, 5, 0];
export const PRICE_UNITS = ["doba", "noc", "godzina", "usluga"];
export const UNIT_LABEL = {
    pl: { doba: "za dobę", noc: "za noc", godzina: "za godzinę", usluga: "za usługę" },
    en: { doba: "per day", noc: "per night", godzina: "per hour", usluga: "per service" },
    de: { doba: "pro Tag", noc: "pro Nacht", godzina: "pro Stunde", usluga: "pro Leistung" },
    fr: { doba: "par jour", noc: "par nuit", godzina: "par heure", usluga: "par prestation" },
    it: { doba: "al giorno", noc: "a notte", godzina: "all’ora", usluga: "a servizio" },
    es: { doba: "por día", noc: "por noche", godzina: "por hora", usluga: "por servicio" },
    zh: { doba: "每天", noc: "每晚", godzina: "每小时", usluga: "每项服务" },
    ja: { doba: "1日あたり", noc: "1泊あたり", godzina: "1時間あたり", usluga: "1件あたり" },
    ko: { doba: "1일당", noc: "1박당", godzina: "시간당", usluga: "서비스당" },
};
/** Katalog kategorii bazowych z prototypu. */
export const CATEGORIES = [
    { id: "rooms", label: "Pokoje", labelEn: "Rooms", type: "day", unit: "noc" },
    { id: "cars", label: "Samochody", labelEn: "Cars", type: "day", unit: "doba" },
    { id: "attr", label: "Atrakcje", labelEn: "Attractions", type: "time" },
    { id: "hair", label: "Fryzjer", labelEn: "Hairdresser", type: "time" },
    { id: "beauty", label: "Kosmetyka", labelEn: "Beauty", type: "time" },
    { id: "med", label: "Medyczne", labelEn: "Medical", type: "time" },
];
/** Kolory kategorii — wyłącznie barwy z palety NO-HUMAN PSA. */
export const CAT_COLOR = {
    rooms: "#3E2712",
    cars: "#13294B",
    attr: "#FF5C00",
    hair: "#8C1D40",
    beauty: "#17C9A0",
    med: "#4F8DFF",
};
export const CAT_VIVID = {
    rooms: "#E6AE16",
    cars: "#4F8DFF",
    attr: "#FF6A1A",
    hair: "#D24268",
    beauty: "#22D3AA",
    med: "#4F8DFF",
};
/** Paleta kolorów klienta — stabilna, z palety systemu. */
export const CLIENT_COLORS = [
    { bg: "#FF5C00", fg: "#FFFFFF" },
    { bg: "#13294B", fg: "#FFFFFF" },
    { bg: "#17C9A0", fg: "#0C0D10" },
    { bg: "#8C1D40", fg: "#FFFFFF" },
    { bg: "#C8930A", fg: "#0C0D10" },
    { bg: "#4F8DFF", fg: "#FFFFFF" },
    { bg: "#3E2712", fg: "#FFFFFF" },
    { bg: "#D24268", fg: "#FFFFFF" },
];
/** Kanały komunikacji wybierane per klient. */
export const CLIENT_CHANNELS = ["phone", "sms", "email", "whatsapp", "messenger"];
export const DEFAULT_CLIENT_CHANNELS = ["phone", "sms", "email"];
/** Wszystkie kanały, którymi potrafi wysyłać platforma. */
export const INTEGRATION_CHANNELS = [
    "phone",
    "sms",
    "whatsapp",
    "messenger",
    "telegram",
    "signal",
    "teams",
    "email",
];
/**
 * Kanały konfigurowane przez operatora w panelu.
 * E-mail jest kanałem platformowym — nie wymaga poświadczeń tenanta i jest domyślnie
 * dostępny, dlatego nie ma własnej karty (tak jak w prototypie panelu).
 */
export const OPERATOR_CHANNELS = INTEGRATION_CHANNELS.filter((c) => c !== "email");
/**
 * Plany platformy = progi cennika.
 *
 * Jedno źródło prawdy: gdyby lista żyła tu osobno od `TIERS`, walidacja
 * rejestracji przyjmowałaby plan, którego cennik nie zna — albo odwrotnie.
 */
export const PLANS = TIERS;
//# sourceMappingURL=constants.js.map